import CssBaseline from "@mui/material/CssBaseline";
import { Box, Typography } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useMemo, type ReactNode } from "react";
import { AuthProvider } from "react-oidc-context";
import TMHubReport from "./pages/TMHubReport/TMHubReport";
import { AuthLayout } from "./auth/AuthLayout";
import { AuthTokenBridge } from "./auth/AuthTokenBridge";
import { getCognitoAuthConfig, onSigninCallback } from "./auth/cognitoAuthConfig";

const theme = createTheme({
  typography: {
    fontFamily: '"Nunito Sans", "Nunito", system-ui, sans-serif',
  },
});

function CognitoAuthRoot({ children }: { children: ReactNode }) {
  const { oidcConfig, configError } = useMemo(() => {
    try {
      return { oidcConfig: getCognitoAuthConfig(), configError: null as string | null };
    } catch (e) {
      const msg = e instanceof Error ? e.message : String(e);
      return { oidcConfig: null, configError: msg };
    }
  }, []);

  if (configError || !oidcConfig) {
    return (
      <Box sx={{ p: 3, maxWidth: 560 }}>
        <Typography variant="h6" gutterBottom>
          Auth Configuration error
        </Typography>
      </Box>
    );
  }

  return (
    <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      <AuthTokenBridge>{children}</AuthTokenBridge>
    </AuthProvider>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CognitoAuthRoot>
        <AuthLayout>
          <TMHubReport />
        </AuthLayout>
      </CognitoAuthRoot>
    </ThemeProvider>
  );
}

export default App;
